import type { SVGProps } from "react";

export default function CircleSlashIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="1.1" />
      <path
        d="M3.64 3.64 16.36 16.36"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
      />
    </svg>
  );
}
